import Image from 'next/image'
import type { FC } from 'react'
import type { FooterColumnStoreLinkGroup } from '../../../types'
import { Hyperlink } from '@/tools/ui'

interface FooterLinkProps {
  item: FooterColumnStoreLinkGroup
}

export const FooterStoreLink: FC<FooterLinkProps> = ({ item }) =>
  item.storeLinks.map((link) => (
    <Hyperlink key={link.href} href={link.href}>
      <Image alt="store links" height={link.heightPx} src={link.img} width={link.widthPx} />
    </Hyperlink>
  ))
